import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CssBaseline, Grid } from '@material-ui/core';
import Header from './components/Header'
import List from './components/List';
import { getAllUser, getTechDataDate } from './api/webGeolocApi';
import "./App.css";
import Map from './components/Map';
import Footer from './components/Footer';



const App = () => {

  const { idservice } = useParams();

  const [user, setUser] = useState();
  const [allUser, setAllUser] = useState([]);
  const [d, setD] = useState()
  const [type, setType] = useState([]);
  const [time, setTime] = useState()
  const [technicien, setTechnicien] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [DDATA, setDDATA] = useState([]);
  const [isData, setIsData] = useState(false);
  const [verifyData, setVerifyData] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);
  const onItemClick = useCallback((n) => {
    setTechnicien(n)
    //setStartDate(n1)
    //setEndDate(n2)
    //setIsActive(true);
    setStartAnimation(false);

  }, []);

  const onSelectedDateStart = useCallback((n) => {
    setStartDate(n);

  }, []);

  const onSelectedDateEnd = useCallback((n) => {
    setEndDate(n);
  }, []);



  const tblType = [];
  const tblDataUser = [];
  const tblDate = [];
  const positions = []
 

  const startSnake = () => setStartAnimation(true);

  useEffect(() => {
    if (technicien !== null && startDate !== null && endDate !== null) {
      setVerifyData(true);
      setStartAnimation(false);
      getTechDataDate(technicien, (new Date(startDate?.toISOString()).toLocaleString("sv-SE")), (new Date(endDate?.toISOString()).toLocaleString("sv-SE")), idservice).then((res) => {


        for (let i = 0; i < res?.length; i++) {
          const element = res[i].terminalLocation.currentLocation;
          const elementType =  res[i].terminalLocation.eventType
          if (element !== undefined && (elementType === "EPIFTTH_GEOLOC_EVENT" || elementType === "EPIFTTH_GEOLOC_SOS_EVENT") ) {
            tblDataUser.push(element);
            setType(res[i].terminalLocation.eventType);
            tblDate.push(new Date(res[i]["@timestamp"]).toLocaleString());
            tblType.push(res[i].terminalLocation.eventType);
          }
        }
        setType(tblType);
        setD(tblDataUser);
        setIsData(true);
        setTime(tblDate);
        if (tblDataUser.length === 0) { setVerifyData(false); }
        tblDataUser?.map((pos, i) => positions.push([pos.latitude, pos.longitude]));
        setDDATA(positions);
        setIsData(true);
      })
    } else if (technicien === null && startDate === null && endDate === null) {
      setVerifyData(false);
    } else if (technicien !== null && startDate === null && endDate === null) {
      setVerifyData(false);
      setAllUser(null);

    } else if (technicien !== null || (startDate === null || endDate !== null)) {
      setVerifyData(false);
      setAllUser(null);
      setTechnicien(null)
    }
  }, [user, technicien, startDate, endDate]);


  useEffect(() => {

    // Named function "getUsers"
    async function getUsers() {

      try {
        const users = await getAllUser((new Date(startDate?.toISOString()).toLocaleString("sv-SE")), (new Date(endDate?.toISOString()).toLocaleString("sv-SE")), idservice)
        setAllUser(users);

      } catch (err) {
        setAllUser(null);
      }
    }
    if (startDate !== null && endDate !== null) {
      // Call named function
      getUsers();
    }
  }, [startDate, endDate]);

  return (
    <>
      <CssBaseline />
      <Header />
      {<Grid container spacing={3} style={{ width: '100%' }} >
        <Grid item xs={12} md={4}>
          <List allUser={allUser} onItemClick={onItemClick} onSelectedDateStart={onSelectedDateStart} onSelectedDateEnd={onSelectedDateEnd} />
        </Grid>
        <Grid item xs={12} md={8} >
          <Map data={d} isData={isData} startSnake={startSnake} startAnimation={startAnimation} positions={DDATA} type={type} tme={time} verifyData={verifyData} />
        </Grid>
      </Grid>}
      <Footer />
    </>
  );
};

export default App;
